import { AutogenLayoutTimecardHistoryDetails } from "./autogen/AutogenLayoutTimecardHistoryDetails";
import {
    ClickEvent, DataDisplayEvent, DataSourceMode, DataSourceModeChangeEvent, Layout, Textbox
} from "@mcleod/components";
import { getPayrollControlBoolean } from "@mcleod/general";
import { AutogenLayoutJobClassLookup } from "./autogen/AutogenLayoutJobClassLookup";
import { CommonDialogs } from "@mcleod/common";
import { HorizontalAlignment, ModelRow } from "@mcleod/core";

export class TimecardHistoryDetails extends AutogenLayoutTimecardHistoryDetails {
    onLoad(): void | Promise<void> {
        this.textboxAddlTaxOverrideHours.visible = getPayrollControlBoolean("addl_tax_override_hours", false);
        this.sourceDrsTimecardHist.addAfterModeChangeListener((event: DataSourceModeChangeEvent) => {
            this.buttonJobClassification.visible = event.newMode === DataSourceMode.SEARCH;
        });
    }

    /** This is an event handler for the onClick event of buttonJobClassification. */
    async buttonJobClassificationOnClick(event: ClickEvent) {
        const layout = Layout.getLayout("lme/settlement/JobClassLookup") as AutogenLayoutJobClassLookup;
        CommonDialogs.showDialog(layout, {
            title: "Job Classification Lookup",
            okProps: {
                onClick: () => {
                    if (this.mainDataSource.mode === DataSourceMode.SEARCH) {
                        if (layout.tableJobClass.selectedRow != null) {
                            const selectedRow = layout.tableJobClass.selectedRow.data as ModelRow;
                            this.activeRow.setLookupModelData("job_class_code_id", selectedRow.getLookupModelData("id"));
                            this.activeRow.set("job_class_code_id", selectedRow.get("id"));
                            this.activeRow.setLookupModelData("division_id", selectedRow.getLookupModelData("division_id"));
                            this.activeRow.set("division_id", selectedRow.get("division_id"));
                            this.activeRow.setLookupModelData("terminal_id", selectedRow.getLookupModelData("terminal_id"));
                            this.activeRow.set("terminal_id", selectedRow.get("terminal_id"));
                        }
                    }
                }
            }
        });
    }

    unitsOnDisplay(event: DataDisplayEvent) {
        const textbox = event.target as Textbox;
        textbox.captionProps = { align: HorizontalAlignment.RIGHT, fontBold: true, color: "default" };
    }
}
